<template>
  <div class="dropdown">
    <button class="btn select-option" @click="showMenu">
      <span class="inner-text">{{ link }}</span>
      <span class="down-arrow"><i class="fas fa-arrow-down"></i></span>
    </button>
    <div
      class="dropdown-menu w-100"
      :class="showDropDownMenu ? 'show' : ''"
      aria-labelledby="dropdownMenuButton"
    >
      <a class="dropdown-item" href="#" @click.prevent="setRpc('greymass')"
        >Greymass</a
      >
      <a class="dropdown-item" href="#" @click.prevent="setRpc('pink.gg')"
        >pink.gg</a
      >
      <a class="dropdown-item" href="#" @click.prevent="setRpc('EOS Rio')"
        >EOS Rio</a
      >
      <a class="dropdown-item" href="#" @click.prevent="setRpc('GreenEOSIO')"
        >Green EOSIO</a
      >
      <!-- <a class="dropdown-item" href="#" @click.prevent="setRpc('test')">Test</a> -->
    </div>
  </div>
</template>

<script>
export default {
  nam: "RpcServe",
  data() {
    return {
      showDropDownMenu: false,
      link: "Please select RPC Server",
    };
  },
  methods: {
    showMenu() {
      this.showDropDownMenu = !this.showDropDownMenu;
    },
    setRpc(producers) {
      if (producers == "EOS Rio") {
        localStorage.setItem("rpc-asset-key", "https://atomic.wax.eosrio.io");
        localStorage.setItem("rpc-link-key", "wax.eosrio.io");
      } else if (producers == "pink.gg") {
        localStorage.setItem("rpc-asset-key", "https://wax-aa.eosdac.io");
        localStorage.setItem("rpc-link-key", "wax.pink.gg");
      } else if (producers == "greymass") {
        localStorage.setItem(
          "rpc-asset-key",
          "https://wax.api.atomicassets.io"
        );
        localStorage.setItem("rpc-link-key", "wax.greymass.com");
      } else if (producers == "test") {
        localStorage.setItem(
          "rpc-asset-key",
          "https://test.wax.api.atomicassets.io"
        );
        localStorage.setItem("rpc-link-key", "testnet.wax.eosdetroit.io");
      } else {
        localStorage.setItem("rpc-asset-key", "https://wax-aa.eosdac.io");
        localStorage.setItem("rpc-link-key", "wax.pink.gg");
      }
      this.link = producers;
      this.showDropDownMenu = !this.showDropDownMenu;
    },
  },
};
</script>

<style scoped>
.dropdown-menu a:hover,
.btn:hover {
  color: rgba(57, 51, 51, 0.4);
  background: transparent !important;
  border-color: #fff !important;
  transition: color 0.4s linear;
}
.btn:focus {
  border-color: #fff !important;
  color: #fff;
}
.select-option {
  border: 2px solid white;
  color: #fff;
  padding: 0;
}
.inner-text {
  padding: 10px 20px;
  text-transform: uppercase;
  font-weight: bold;
  width: 265px !important;
  display: inline-block;
}
.down-arrow {
  display: inline-block;
  border-left: 1px solid #fff;
  padding: 10px;
}
</style>